import {
  AGENT_STATUS_WAITING_FOR_CLARIFICATION,
  DELIVERY_STATUS_BACKLOG
} from "../../domainCatalog";
import { assignmentLabel, deliveryStatusClass } from "./taskStudioUtils";

export const TicketRow = ({
  ticket,
  child,
  selected,
  expanded,
  onToggle,
  onSelect,
  onCreateSubtask,
  assignee,
  reviewer,
  disabled,
  draggable,
  dragging,
  onDragStart,
  onDragEnd,
  onDrop
}) => (
  <div
    className={`task-ticket-row ${child ? "child" : ""} ${selected ? "selected" : ""} ${dragging ? "dragging" : ""}`}
    draggable={draggable && !disabled}
    onDragStart={onDragStart}
    onDragEnd={onDragEnd}
    onDragOver={(event) => event.preventDefault()}
    onDrop={(event) => {
      event.preventDefault();
      onDrop?.();
    }}
  >
    <span className="task-drag-handle" title="Drag to reorder">⋮⋮</span>
    {!child && <button className="task-expand" onClick={onToggle} disabled={disabled}>{expanded ? "⌄" : "›"}</button>}
    <button className="task-ticket-main" onClick={onSelect}>
      <span className={`task-type-icon ${child ? "subtask" : "story"}`}>{child ? "↳" : "▱"}</span>
      <span className="task-ticket-id">TS-{ticket.id}</span>
      {ticket.workstream_name && <span className="task-ticket-id">{ticket.workstream_name}</span>}
      <span>{ticket.title}</span>
      <span className={`task-assignee ${assignee ? "" : "unassigned"}`}>{assignmentLabel(assignee, reviewer)}</span>
      <span className={`task-delivery-status ${deliveryStatusClass(ticket.delivery_status)}`}>{ticket.delivery_status || DELIVERY_STATUS_BACKLOG}</span>
      <span className="task-complexity">{ticket.complexity}</span>
    </button>
    {!child && <button className="task-add-subtask" onClick={onCreateSubtask} disabled={disabled}>+ Sub-task</button>}
  </div>
);

export const ListField = ({ label, value, disabled, onChange }) => (
  <label>{label}<textarea rows="4" value={value.join("\n")} disabled={disabled} onChange={(event) => onChange(event.target.value.split("\n").filter(Boolean))} /></label>
);

export const AgentJobPanel = ({ job, answer, onAnswerChange, onAnswer, loading }) => (
  <section className="task-agent-job">
    <div className="task-agent-job-heading">
      <div>
        <strong>AI Engineer</strong>
        <span>{job ? `${job.phase} · ${job.model}` : "Ready to start"}</span>
      </div>
      {job && <span className={`task-agent-status ${job.status}`}>{job.status.replaceAll("_", " ")}</span>}
    </div>
    {!job ? (
      <p>Start the assigned AI Engineer after saving the ticket. It will create a branch and pull request for the accountable reviewer.</p>
    ) : (
      <>
        <p>{job.status_message}</p>
        {job.base_branch && <small>PR target branch: <code>{job.base_branch}</code></small>}
        <small>Estimated model cost: ${(job.estimated_cost || 0).toFixed(4)}</small>
        {job.status === AGENT_STATUS_WAITING_FOR_CLARIFICATION && (
          <div className="task-agent-clarification">
            {(job.clarification_questions || []).map((question, index) => <p key={index}><strong>{question}</strong></p>)}
            <textarea value={answer} onChange={(event) => onAnswerChange(event.target.value)} placeholder="Answer the AI Engineer's questions..." />
            <button onClick={onAnswer} disabled={loading || !answer.trim()}>Send clarification</button>
          </div>
        )}
        {!!(job.changed_files || []).length && (
          <div className="task-agent-files"><strong>Changed files</strong>{job.changed_files.map((path) => <code key={path}>{path}</code>)}</div>
        )}
        {job.pull_request_url && <a href={job.pull_request_url} target="_blank" rel="noreferrer">Open pull request #{job.pull_request_number}</a>}
        {!!(job.events || []).length && (
          <details><summary>Execution log</summary><div className="task-agent-events">{job.events.map((event) => <span key={event.id}>{event.message}</span>)}</div></details>
        )}
        <p className="task-agent-safety">Taskit does not execute customer code or merge automatically. The human reviewer validates the PR.</p>
      </>
    )}
  </section>
);
